import { OperationsMenuActions } from '../../constants';
import initialState from '../../initialState';

const reducer = (state = initialState.OperationsMenu, action = {}) => {
  switch (action.type) {
    case OperationsMenuActions.CHANGE_TYPE:
      return {
        ...state,
        embeddingType: action.embeddingType,
      };
    default:
      return state;
  }
};
export default reducer;
